import { createAction } from 'redux-actions';
import uuid from 'uuid/v4';
import {
  createParams,
} from './common';
import Product from './product';
import * as types from '../../constants/Api';

class TJMService extends Product {
  static CAR_TJM_PAYMENT = 'tjmproduct/v1/payment';

  static createPayment = createAction(types.PAYMENT_CREATE);
  static createdPayment = createAction(types.PAYMENT_CREATED);
  
  createPaymentAction(payload) {
    return dispatch => dispatch(TJMService.createPayment(payload));
  }
  createdPaymentAction(payload) {
    return dispatch => dispatch(TJMService.createdPayment(payload));
  }

  tjmPayment(params, formValues) {
    return (dispatch, getState) => {
      return (dispatch(super.createCustomerV2(params, formValues, null))
        .then((response) => {
          const state = getState();
          const values = { ...formValues, ...state.userData };
          const mappedParams = params
            ? createParams(params, values, state)
            : {};
          const requestParams = {
            general: {
              globalTransactionId: uuid(),
            },
            rolePlayerId: response.customer.rolePlayerId,
            ...mappedParams,
          };
          dispatch(this.createPaymentAction());
          return this.callApiPost(
            TJMService.CAR_TJM_PAYMENT,
            requestParams,
            dispatch
          ).then((data) => {
            dispatch(this.createdPaymentAction(data));
          });
        })
      );
    };
  }

  paymentType(params, formValues) {
    return (dispatch, getState) => {
      const state = getState();
      const values = { ...formValues, ...state.userData };
      const mappedParams = params
        ? createParams(params, values, state)
        : {};
      const requestParams = {
        general: {
          globalTransactionId: uuid(),
        },
        rolePlayerId: state.userData.rolePlayerId,
        ...mappedParams,
      };
      dispatch(this.createPaymentAction());
      return this.callApiPost(
        TJMService.CAR_TJM_PAYMENT,
        requestParams,
        dispatch
      ).then((data) => {
        dispatch(this.createdPaymentAction(data));
      });
    }
  }
}

export const tjmService = new TJMService();